// Company Main Employer ********************************************************************************
// pathname: /v1/company/main-employer/{id}
// ************************************************************************************************
import { ApiCompanyMainEmployerOk, useSwrApi } from 'src/hooks/useSwrApi';


/**
 * @description SWR: fetch main employer data for a company
 * @param accountId - { number } - the account id of the company.
 * @param locale - { string } - the locale to use for the request. Default: 'ro'.
 */
export const useSwrCompanyMainEmployer = (accountId?: number, locale = 'ro') => {
  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiCompanyMainEmployerOk>({
    url: `/v1/company/main-employer/${accountId}`,
    locale,
    shouldFetch: !!accountId,
    apiOptions: {
      dedupingInterval: 60 * 1000 * 2, // 2 minutes
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
